const LP_URL = "https://lp.ambii.com";

const REDIRECT_PATHS = new Set([
  "/",
  "/form",
  "/form/clinic",
  "/appointment",
  "/appointment/clinic",
]);

const LOCALE_PREFIX_PATTERN =
  /^\/(en|zhCn|vi|zhTw|pt|es|fr|ko|th|ne|tl|id|my)(?=\/|$)/;

function normalizePath(path: string): string {
  const withoutTrailingSlash = path.replace(/\/+$/, "") || "/";
  return withoutTrailingSlash.replace(LOCALE_PREFIX_PATTERN, "") || "/";
}

export default function ({ route, redirect }) {
  if (process.env.STAGE !== "PRD") return;

  if (REDIRECT_PATHS.has(normalizePath(route.path))) {
    return redirect(LP_URL);
  }
}
